import DefaultElementNodeType from '../DefaultElementNodeType';
import {STRATEGY_RESOURCE} from '../../metamodel/Concept';

export default class ResourceNodeType extends DefaultElementNodeType {
	static get typeName() {
		return STRATEGY_RESOURCE;
	}
}
